/**
 * @file
 * Behaviors for the Input for Global Search.
 */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Input for Global Search behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.inputGlobalSearch = {
    attach: function(context) {
      const self = this;
      const $input = $('#input-global-search', context);
      const $inputButton = $('.input-global-search__button', context);

      $inputButton.on('click', function() {
        self.toggleClickEvent($input);
      });

      $input.on('keyup', function(e) {
        if (e.key === 'Enter') {
          self.submitEvent(e.target.value);
        }
      });
    },

    toggleClickEvent: function($input) {
      $input.focus();
    },

    submitEvent: function(queryString) {
      const currentLang = drupalSettings.path.currentLanguage;
      if (currentLang === 'es') {
        const path = `/buscar?query=${queryString}`;
        window.location = path;
        return;
      }
      const path = `/${currentLang}/buscar?query=${queryString}`;
      window.location = path;
    }
  };
})(Drupal, jQuery);
